/**
 * HomeLayoutAuthorSpotlight - Author spotlight homepage layout wrapper
 * Applies CSS class for author-focused styling; children handle article rendering
 */
import React from 'react';

const HomeLayoutAuthorSpotlight = ({ children }) => {
    return (
        <div className="home-layout home-layout--author-spotlight">
            <div className="home-layout__body">
                {children}
            </div>
        </div>
    );
};

export default HomeLayoutAuthorSpotlight;
